export const ARROW_LEFT_ICON = require('./arrow-left.png')
export const ARROW_RIGHT_PRIMARY_ICON = require('./arrow-right-primary.png')
export const CLOSE_WHITE_ICON = require('./close-white.png')
export const CURRENT_LOCATION_ICON = require('./current-location.png')
export const CATEGORY_SELECT_ICON = require('./category-select.png')
export const HOME_ICON = require('./home.png')
export const KAKAO_ICON = require('./kakao-icon.png')
export const MAP_ICON = require('./map.png')
export const PROFILE_IMG_PLACEHOLDER_IMAGE = require('./profile-img-placeholder.png')
export const SEARCH_ICON = require('./search.png')
export const FILTER_ICON = require('./filter.png')
export const EDIT_ICON = require('./edit.png')
